import React from 'react';
import { gsap, Expo } from 'gsap';

const Preloader = () => {
  const [tl] = React.useState(gsap.timeline({ paused: false }));

  let preloader = React.useRef(null);
  let preloaderBg = React.useRef(null);
  let preloaderWrapper = React.useRef(null);
  let lineDynamic = React.useRef(null);
  let counter = React.useRef(null);

  let count = {
    val: 0,
  };

  React.useEffect(() => {
    tl.to(count, {
      duration: 2.5,
      val: 100,
      onUpdate() {
        counter.textContent = `${Math.ceil(count.val)}%`;
      },
    })
      .to(lineDynamic, 2.5, {
        width: '100%',
        ease: Expo.easeInOut,
        delay: -2.5,
      })
      .to(preloaderWrapper, 2, { y: 0, ease: Expo.easeInOut, delay: -0.5 })
      .to(preloaderBg, 0.6, {
        y: '100%',
        opacity: 0,
        ease: Expo.easeInOut,
        delay: -1.07,
      })
      .to(counter, 0.3, { opacity: 0, ease: Expo.easeInOut, delay: -1.05 })
      .to(preloader, 0.1, {
        pointerEvents: 'none',
        opacity: 0,
        ease: Expo.easeInOut,
      });
  });

  return (
    <div className="preloader" ref={(e) => (preloader = e)}>
      <div
        className="preloader-background"
        ref={(e) => (preloaderBg = e)}
      ></div>
      <div className="preloader-wrapper" ref={(e) => (preloaderWrapper = e)}>
        <div className="preloader-count" ref={(e) => (counter = e)}>
          {count.val}
        </div>
        <div className="preloader-lines__wrapper">
          <div className="preloader-lines">
            <div
              className="preloader-lines__dynamic"
              ref={(e) => (lineDynamic = e)}
            ></div>
            <div className="preloader-lines__static"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
